import { HttpClient }  from '@angular/common/http';
import {
  Inject,
  Injectable,
}                      from '@angular/core';
import {
  PaymentData,
  PredictClientResponse,
  SimpleClient,
}                      from '~domain/types';
import { ENVIRONMENT } from '../app.constants';

@Injectable({
  providedIn: 'root',
})
export class DocumentApiService {

  constructor(@Inject(ENVIRONMENT) private readonly environment: Environment,
              private readonly http: HttpClient) {
  }

  downloadDocument(id: string, clientId?: string) {
    const url = clientId
      ? `${this.environment.api}/clients/${clientId}/documents/${id}`
      : `${this.environment.api}/documents/${id}`;
    return this.http.get<Blob>(url, { responseType: 'blob' as 'json' });
  }

  renameDocument(name: string, documentId: string, clientId?: string) {
    const body = { name: name.trim() };
    const url = clientId
      ? `${this.environment.api}/clients/${clientId}/documents/${documentId}`
      : `${this.environment.api}/documents/${documentId}`;
    return this.http.patch<void>(url, body);
  }

  assignDocuments(documentIds: string[], clientId: string) {
    return this.http.post<void>(
      `${this.environment.api}/process-documents-requests`,
      { ids: documentIds, clientId, type: 'ASSIGN' },
    );
  }

  setDocumentHidden(hidden: boolean, documentId: string, clientId?: string) {
    const body = { hidden };
    const url = clientId
      ? `${this.environment.api}/clients/${clientId}/documents/${documentId}`
      : `${this.environment.api}/documents/${documentId}`;
    return this.http.patch<void>(url, body);
  }

  setDocumentShared(shared: boolean, documentId: string, clientId?: string) {
    const body = { shared };
    const url = clientId
      ? `${this.environment.api}/clients/${clientId}/documents/${documentId}`
      : `${this.environment.api}/documents/${documentId}`;
    return this.http.patch<void>(url, body);
  }

  deleteDocuments(documentIds: string[]) {
    return this.http.post<void>(
      `${this.environment.api}/process-documents-requests`,
      { ids: documentIds, type: 'DELETE' },
    );
  }

  getDocumentPaymentData(id: string) {
    return this.http.get<PaymentData>(`${this.environment.api}/documents/${id}/payment-data`);
  }

  fetchClients() {
    return this.http.get<SimpleClient[]>(`${this.environment.api}/simple-clients`);
  }

  predictClient(id: string) {
    return this.http.post<PredictClientResponse>(`${this.environment.api}/documents/${id}/predict-client-requests`, null);
  }
}
